export const pl = {
    "TRIGGER_LISTEN": "Nasłuchiwanie wyzwalaczy",
    "ASSIST_EMPTY_MSG": "Agent AI aktywnie nasłuchuje Twojej rozmowy i jest gotów automatycznie pomóc po wyzwoleniu.",
    "MYBOT_TRIGGET_LISTEN": "Obecnie brak aktywnych zadań My Bot",
    "MYBOT_EMTPY_MSG": "Aby rozpocząć zadanie na My Bot, przejdź do zakładki wyszukiwania i wybierz opcję \"Uruchom z danymi agenta\" dla wybranego zadania.",
    "PROACTIVE_MODE": "Tryb Proaktywny",
    "SETTINGS": "Ustawienia",
    "HELP_AND_SUPPORT": "Pomoc i wsparcie",
    "HELP": "Pomoc",
    "LANGUAGE": "Język",
    "THEME": "Motyw",
    "AUTOMATIC": "Automatyczny",
    "FILE_NAME":"Nazwa pliku",
    "DARK": "Ciemny",
    "AUTO_SCROLL_TOOLTIP":"Kontroluje automatyczne przewijanie karty Pomoc, Mojego bota i zawartości karty Transkrypt",
    "LIGHT": "Jasny",
    "THEME_DESC": "To użyje domyślnego trybu systemowego",
    "DOCUMENTATION": "Dokumentacja",
    "DOC_DESC": "Sprawdź nasze szczegółowe artykuły dokumentacyjne.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Sprawdź najczęściej zadawane pytania dotyczące Agenta AI.",
    "KORE_ACADEMY": "Akademia Kore",
    "KORE_ACA_DESC": "Dowiedz się więcej o Agencie AI, uczestnicząc w kursach akademickich.",
    "SEARCH": "Szukaj",
    "MY_BOT": "Mój Bot",
    "TAP_SEARCH":"Stuknij, aby wyszukać",
    "ASSIST": "Pomoc",
    "TRANSCRIPT": "Transkrypt",
    "HISTORY": "Historia",
    "STARTOVER": "Rozpocznij od nowa",
    "RESTART_INPUTS": "Uruchom ponownie z zebranymi danymi",
    "ASKCUSTOMER": "Zapytaj klienta",
    "TELLCUSTOMER": "Powiedz klientowi",
    "WELCOME_MSG": "Wiadomość powitalna",
    "SEND": "Wyślij",
    "SENT": "Wysłano",
    "AWAITING": "Oczekiwanie na odpowiedź | Wpisz, aby kontynuować",
    "OVERRIDE": "Wpisz, aby kontynuować",
    "OVERRIDE_FILE": "Załącz plik, aby kontynuować",
    "ACCEPT_RESPONSE": "Odpowiedź zaakceptowana",
    "AGENT_ENTERED": "Agent dołączył",
    "EXPECTED_FORMAT": "Oczekiwany format",
    "INPUT_VALUES": "Wartości wejściowe",
    "RESTART": "Uruchom ponownie",
    "START_OVER": "Rozpocznij od nowa",
    "RESTART_CAPTURE": "Uruchom ponownie z zebranymi danymi",
    "CANCEL": "Anuluj",
    "INTERRUPT_DIALOG": "PRZERWANY ZADANIE DIALOGOWE",
    "RUN": "URUCHOM",
    "RUN_AGENT": "Uruchom z danymi agenta",
    "STEP": "Krok",
    "DIALOG_TASK": "Zadanie dialogowe",
    "FAQ": "FAQ",
    "SNIPPET": "Odpowiedzi",
    "ARTICLE": "Strony internetowe",
    "FILE": "Pliki",
    "SUGGESTED": "Sugerowane",
    "ALL_DIALOG": "Wszystkie zadania dialogowe",
    "DIALOG_TEXT": "Dialog",
    "INTENT_IDENTIFIED": "Wypowiedź klienta",
    "NOT_WHAT_LOOKING": "Zła sugestia?",
    "BOT": "Bot",
    "CUSTOMER": "Klient",
    "YOU": "Ty",
    "TERMINATE_CONV": "Zakończ zadanie dialogowe",
    "TERMINATE_CONV_DESC": "Czy na pewno chcesz zakończyć zadanie dialogowe? Agent AI nie będzie mógł już składać sugestii.",
    "YES_TERMINATE": "Tak, zakończ",
    "NO_CANCEL": "Nie, anuluj",
    "OVERRIDE_CONTINUE": "Kontynuuj w trybie nadpisania",
    "SUMMARY_TEXT": "Podsumowanie",
    "SUBMIT": "Zatwierdź",
    "INTERRUPT_OCCURED": "Wystąpiła przerwa",
    "IDENTIFIED_INTENT": "Zidentyfikowana intencja",
    "INTERRUPT_DESC": "Uruchomienie tego spowoduje zakończenie bieżącego zadania dialogowego.",
    "ACCEPT_RUN": "Zaakceptuj i uruchom",
    "RUN_LATER": "Uruchom później",
    "KNOW_MORE": "Dowiedz się więcej",
    "MORE_TEXT": "Więcej",
    "LESS_TEXT": "Mniej",
    "VIEW_MORE": "Zobacz więcej",
    "VIEW_LESS": "Zobacz mniej",
    "SHOW_MORE_FAQ": "Pokaż więcej FAQ",
    "SHOW_LESS_FAQ": "Pokaż mniej FAQ",
    "SHOW_MORE_ARTICLE": "Pokaż więcej stron internetowych",
    "SHOW_LESS_ARTICLE": "Pokaż mniej stron internetowych",
    "SHOW_MORE_SNIPPET": "Pokaż więcej odpowiedzi",
    "SHOW_LESS_SNIPPET": "Pokaż mniej odpowiedzi",
    "SHOW_MORE_FILES": "Pokaż więcej plików",
    "SHOW_LESS_FILES": "Pokaż mniej plików",
    "VIEW_ALL_DIALOG": "Zobacz wszystkie dialogi",
    "VIEW_FEW_DIALOG": "Zobacz kilka dialogów",
    "HELP_FULL": "Pomocne?",
    "THANKYOU": "Dziękuję!",
    "EXPAND_MORE": "Rozwiń / Więcej",
    "CLOSE_TEXT": "Zamknij",
    "STARTED": "Rozpoczęto",
    "ENDED": "Zakończono",
    "VIEW_FULL_ARTICLE": "Zobacz stronę internetową",
    "VIEW_FULL_FILE": "Zobacz plik",
    "COPIED": "Skopiowano",
    "SENTI_ANALY": "Analiza sentymentu",
    "WRONG_SUGGESTION": "Zła sugestia",
    "INCORRECT_INTENT": "Niepoprawna intencja",
    "ACCIDENTAL_CLICK": "Przypadkowe kliknięcie",
    "TIME_TAKING": "Zabiera czas",
    "TAB_TEXT":"Brak włączonych kart! Proszę włączyć przynajmniej jedną kartę",
    "OTHER": "Inne",
    "PLAYBOOK_EMPTY_MSG": "Wybierz playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI nie może załadować playbooka, ponieważ wszystkie dostępne playbooki są dynamiczne. Kliknij 'Wybierz playbook', aby uzyskać dostęp do playbooka",
    "STAGE": "Etap",
    "PROCEED_TO_CLOSE": "Przejdź do zamknięcia",
    "RECOMENDED_PLAYBOOK": "ZALECANY PLAYBOOK",
    "PRIMARY_SCRIPTS": "PODSTAWOWE SCENARIUSZE",
    "DYNAMIC_SCRIPTS": "DYNAMICZNE SCENARIUSZE",
    "RESUME": "Wznów",
    "ENABLE_CLOSE": "Kliknij przycisk przejścia do zamknięcia, aby aktywować etap zamknięcia",
    "LIST_VIEW": "Widok listy",
    "TERMINATE": "Zakończ",
    "MINIMIZE": "Zminimalizuj",
    "MAXIMIZE": "Maksymalizuj",
    "NO_SEARCH_RESULT": "Nie znaleziono wyników wyszukiwania",
    "SENTIMENT_AWAITING": "Oczekiwanie na sentyment",
    "POSITIVE": "Pozytywny",
    "NEGATIVE": "Negatywny",
    "ASSOCIATED_WORK_NOTES": "Notatki o poprzednich rozwiązaniach",
    "AGENT_JOINED_CONV": "Agent dołączył do rozmowy",
    "AUTOSCROLL_ASSIST": "Automatyczne przewijanie treści zakładki asysty",
    "FILE_SIZE_MSG": "Rozmiar pliku musi być poniżej 25MB. Proszę spróbować ponownie.",
    "OVERRIDE_BTN": "Nadpisz",
    "PLAYBOOK": "Playbook",
    "CHOOSE_FILE": "Wybierz plik",
    "SUMMARY_ERROR_TEXT": "Przykro nam, ale wystąpił problem podczas generowania podsumowania tej rozmowy. Proszę stworzyć własne podsumowanie.",
    "ASK_A_QUESTION": "Zadaj pytanie",
    "COPY": "Kopiuj",
    "TELL_US_MORE": "Powiedz nam więcej…",
    "THANKS_FEEDBACK": "Dziękujemy za Twoją opinię",
    "SOMETHING_WRONG": "Coś poszło nie tak",
    "CLICK_ERROR_DETAILS": "Kliknij, aby zobaczyć szczegóły błędu",
    "NO_ACTIVE_PLAYBOOK": "Brak aktywnego podręcznika",
    "REPHRASE_QUESTION": "Czy możesz sformułować swoje pytanie inaczej lub zapytać o coś innego?",
    "INTERNAL_INFO": "Informacje wewnętrzne",
    "SOURCES": "Źródła",
    "CONVERSATION_SUMMARY": "Podsumowanie rozmowy",
    "WAITING": "Czekam",
    "WIDGET_DISABLED": "Widżet został wyłączony",
    "AI_SETTINGS_DISABLED": "Ustawienia AI są wyłączone! Skontaktuj się z administratorem AI",
    "SERVER_CONNECTION_ERROR": "Błąd podczas łączenia z serwerem",
    "VIEW": "Zobacz",
    "ATTACHMENT_INPUT": "Wprowadzenie załącznika",
    "TYPE_SUMMARY": "Wpisz podsumowanie",
    "VIEW_FULL_ARTICLE_2": "Zobacz cały artykuł",
    "VIEW_FULL_FILE_2": "Zobacz cały plik",
    "BY":"Przez",
    GENERATE_SUMMARY: "Wygeneruj podsumowanie",
    PREV_SUMMARIES: "Poprzednio wygenerowane podsumowania",
    DIALOG_WORKFLOWS: "Przepływy pracy dialogów",
    SHOW_ALL_DIALOG: "Pokaż wszystkie zadania dialogowe",
    SHOW_ALL_DIALOGS: "Pokaż wszystkie dialogi",
    CUSTOM_TAB: "Niestandardowa karta",
    AGENT_INPUT: "Wejście agenta",
    "CUSTOM_EMPTY_MSG" : "Brak aktywnego przepływu pracy",
    "CUSTOM_TAB_DESC" : "Aby uruchomić przepływ pracy, wykonaj jeden z elementów listy znajdującej się na dole ekranu.",
    "SUBMIT_OVERALL_FEEDBACK" : "Wyślij ogólne opinie",
    "FEEDBACK_POPUP_SUBTITLE" : "Opinie o widżecie i jego funkcjach",
    "FEEDBACK_SATISFIED" : "Zadowolony",
    "FEEDBACK_UNSATISFIED" : "Niezadowolony",
    "FEEDBACK_PROVIDE_REASONS" : "Podaj więcej informacji…",
    "FEEDBACK_TITLE" : "Opinia",
    "AGENTIC_THINKING" : "Myśli",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Tryb Copilota Agentowego",
    "AGENTIC_SENDING_MESSAGE" : "Wysyłanie...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot aktywnie słucha Twojej rozmowy i jest gotowy do automatycznej asysty",
    "AGENTIC_SEARCH_RESULTS" : "Wyniki Agenta",
    "PAUSE_AUTO_SEND" : "Wstrzymaj automatyczne wysyłanie",
    "PAUSE_AGENTIC" : "Wstrzymaj Agenta",
    "RESUME_AGENTIC" : "Wznów Agenta",
    "RESUME_AUTO_SEND" : "Wznów automatyczne wysyłanie"
}